import hambalekvalkovic from '../../resources/hambalek_valkovic.jpg'

export default {
  title: 'Workshopy',
  presenter: 'workshops',
  text: `
Na workshopy se budete moci přihlásit samostatne mailem po přihlášení na konferenci. Cena jednoho workshopu je 250 CZK (10€). Kapacita workshopů je omezena.

![Vlado Hambálek a Ivan Valkovič](${hambalekvalkovic})

## Vlado Hambálek a Ivan Valkovič - Vzťahy v rodine

### Aké hry sa doma hráme?

##### První patro, Salónek Modrý

Na workshope dostanete odpovede na otázky: Prečo je niekedy ťažká intimita a čo ju v rodine nahrádza? Aké psychologické hry hráme, keď nevieme, nechceme alebo nemôžeme komunikovať medzi sebou jasne a úprimne? Prečo je rodina viac než len súčet jednotlivcov a ako vie rodina prežiť aj napriek tomu, že sa v nej nie vždy máme dobre? A možno aj, ako sa mať spolu doma lepšie?

Ivan Valkovič je psychoterapeut v individuálnej, párovej aj rodinnej psychoterapii, zároveň robí supervíziu a poradenstvo. Je otcom troch detí. Vladimír Hambálek je sociálny pracovník, lektor tvorivej dramatiky, tréner a kouč manažmentu, koncentratívno-pohybový psychoterapeut, manželský poradca a mediátor, supervízor. Je otcom dvoch detí.
Spolu založili a vedú Coachingplus - združenie ľudí, ktoré sa špecializuje na rozvoj psychológov, koučov, lektorov, facilitátorov, manažérov, ale aj pedagógov či sociálnych pracovníkov a pôsobí v komerčnom aj nekomerčnom sektore.
  `,
}



// WEBPACK FOOTER //
// ./src/content/vychovakzivotu/data/presentations/c05_workshops_nedela.js